import { Container, Divider } from "@material-ui/core";
import React from "react";
import { StyledButton } from "../helpers/button";
import CellarTech from "../images/cellarTech.png";
import "./marketing.css";
const Marketing = () => {
  return (
    <div className={"marketingContainer"} id="marketing">
      <div className={"imageContainer"}>
        <img src={CellarTech} alt={"CellarTechLogo"} className={"image"} />
        <Divider
          orientation="vertical"
          flexItem
          variant="middle"
          className={"divider"}
        />
        <p className={"cellarTechDesc"}>
          A Digital Agency leading IT Solutions and Services
        </p>
      </div>
      <h1>Join us to get Amazing Deals.</h1>
      <h4>Any industry, any business. We’ve got you covered.</h4>
      <div className={"buttonContainer"}>
        <StyledButton>Get A Quote</StyledButton>
        <StyledButton
          special
          style={{ color: "#2498FB", marginRight: 0 }}
          maxWidth={350}
        >
          Discuss your Idea
        </StyledButton>
      </div>
    </div>
  );
};

export default Marketing;
